export default __webpack_public_path__ + "static/media/screen2.bbae6bcf.png";